<template>
  <ul class="nav flex flex-between wrap">
    <li><router-link to="/">首页</router-link></li>
    <li
      v-for="item in routerList"
      :key="item.id"
      :class="item.subSet && item.subSet.length > 0 ? 'isDrop' : ''"
    >
      <a
        href="javascript:;"
        v-if="!item.isLink"
        @click="goRouter(item.url, item.id)"
        >{{ item.name }}</a
      >
      <a href="javascript:;" v-else @click="goRouter3(item.url)">{{
        item.name
      }}</a>
      <ul class="subnav" v-if="item.subSet && item.subSet.length > 0">
        <li v-for="item2 in item.subSet" :key="item2.id">
          <a
            href="javascript:;"
            v-if="!item2.isLink"
            @click="goRouter2(item.url, item2.id, item.id, item2)"
            >{{ item2.name }}</a
          >
          <a href="javascript:;" v-else @click="goRouter3(item2.url)">{{
            item2.name
          }}</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      routerList: [],
    };
  },
  methods: {
    goRouter(url, id) {
      if (!url) return;
      if (url == "/contact") {
        this.$router.push({
          path: `${url}`,
        });
        return;
      }
      if (url.includes("sybh")) {
        this.$router.push({
          path: `${url}`,
        });
      } else {
        if (id) {
          this.$router.push({
            path: `${url}/${id}`,
          });
          localStorage.setItem("pId", id);
        } else {
          this.$router.push({
            path: `${url}`,
          });
        }
      }
    },
    goRouter2(url, id, ids, item) {
      if (item.subId != "") {
        this.$router.push({
          path: `${url}/${item.subId}`,
        });
      } else {
        this.$router.push({
          path: `${url}/${id}`,
        });
      }
      localStorage.setItem("pId", ids);
    },
    goRouter3(url) {
      if (url.includes("special")) {
        const urls = this.$router.resolve({
          path: `${url}`,
        }).href;
        window.open(urls, "_blank");
      } else {
        window.open(url, "_blank");
      }
    },
    getNavList() {
      this.$request("/web/getNav", "GET").then((res) => {
        this.routerList = res.data.data;
      });
    },
  },
  mounted() {
    this.getNavList();
  },
};
</script>

<style lang="less" scoped>
.nav {
  margin-top: -90px;
  background-color: #1076bf;
  padding: 0 40px;
  position: relative;
  z-index: 20;

  li {
    position: relative;

    > a {
      padding: 18px 42px;
      color: #fff;
    }

    .subnav {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      width: 100%;
      padding: 5px 0;
      font-size: 14px;
      text-align: center;
      list-style: none;
      display: none;
      background-color: #3a86c8;
      -webkit-background-clip: padding-box;
      background-clip: padding-box;
      border: 1px solid #ccc;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

      li {
        border-bottom: 1px solid #2671af;
        &:last-child {
          border-bottom: none;
        }
      }

      a {
        display: block;
        padding: 12px 20px;
        clear: both;
        font-weight: 400;
        line-height: 1.42857143;
        color: #fff;
        white-space: nowrap;
        background: #3583c4;

        &:hover {
          text-decoration: none;
          color: #f5a100;
        }
      }
    }

    &:hover {
      background-color: #3a86c8;
      > a {
        color: #f5a100;
      }

      .subnav {
        display: block;
      }
    }

    &.isDrop {
      > a::before {
        content: "";
        border-top: 7px solid #ffffff;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        position: absolute;
        right: 18px;
        top: 50%;
        margin-top: -2px;
      }
    }
  }
}
</style>